import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { customRequestAccount, CustomRequestAccountApiParameter, CustomRequestAccountModel } from "@nishtech/Services/CustomFormsService";
export interface CustomFormAddress {
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    pincode: string;
}
export interface CustomRequestAccountParameter {
    recepientEmails:string;
    tradeName: string;
    legalBusinessName: string;
    billToAddress: CustomFormAddress;
    billToPhone: string;
    isShipToSameAsBillTo: boolean;
    shipToAddress: CustomFormAddress;
    shipToPhone: string;
    emailAddress: string;
    salesTaxId: string;
    allowToReviewBusinessCredit: boolean;
    contactName: string;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<CustomRequestAccountParameter, CustomRequestAccountApiParameter, ServiceResult<CustomRequestAccountModel>>;

export const PopulateApiParameter: HandlerType = props => {
    const customRequestAccountModel = {
        recepientEmails: props.parameter.recepientEmails,
        tradeName: props.parameter.tradeName,
        legalBusinessName: props.parameter.legalBusinessName,
        billToAddress: props.parameter.billToAddress,
        billToPhone: props.parameter.billToPhone,
        isShipToSameAsBillTo: props.parameter.isShipToSameAsBillTo,
        shipToAddress: props.parameter.shipToAddress,
        shipToPhone: props.parameter.shipToPhone,
        emailAddress: props.parameter.emailAddress,
        salesTaxId: props.parameter.salesTaxId,
        allowToReviewBusinessCredit: props.parameter.allowToReviewBusinessCredit,
        contactName: props.parameter.contactName,
    } as unknown as CustomRequestAccountModel;
    props.apiParameter = { customRequestAccountModel };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await customRequestAccount(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback,ExecuteOnErrorCallback];

const CustomRequestAccountForm = createHandlerChainRunner(chain, "CustomRequestAccountForm");
export default CustomRequestAccountForm;
